<template>
  <el-dialog
    ref="cashierDialog"
    :visible.sync="hasShow"
    width="1000px"
    :before-close="hide"
    :lock-scroll="true"
    :close-on-click-modal="false"
    class="cashier-desk"
  >
    <template #title>
      <div class="header">有看投，让投资大有看头</div>
    </template>
    <div v-if="goodsList" class="cashier-stack">
      <!-- 商品信息 -->
      <div class="goods-wrapper wrapper">
        <div class="goods-item">
          <div class="name">{{ goodsNameTitle }}</div>
          <div class="goods-name">{{ goodsName }}</div>
        </div>
        <div class="goods-item">
          <div class="name">{{ goodsListTitle }}</div>
          <ul class="row">
            <li
              v-for="(item, index) in goodsList"
              :key="item.id"
              class="col"
              :class="{ active: activeIndex === index }"
              @click="changeGoods(index)"
            >
              <slot name="goods" :goods-item="item"></slot>
            </li>
          </ul>
        </div>
      </div>

      <!-- 支付方式 -->
      <div class="wrapper payment-methods-wrapper">
        <div class="goods-item">
          <div class="name">支付方式</div>
          <ul class="row payment-mode-list">
            <li
              v-for="(item, index) in paymentMethodList"
              :key="item.method"
              class="col"
              :class="[
                { active: activePayMethodIndex === index },
                item.class || ''
              ]"
              @click="changePayMethod(index)"
            >
              <img class="payment-mode-icon" :src="item.icon" alt />
              <div class="set-name">
                {{ item.name }}
                <template v-if="item.method === PaymentMethods.caiBi">
                  <span class="balance-num">{{ balance }}</span>
                </template>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 优惠券头部（整行可展开/收起；箭头仅为装饰） -->
      <div
        v-if="showCouponBlock"
        v-loading="orderCouponLoading"
        :class="['wrapper', 'coupon-header-wrapper', { 'coupon-header-wrapper--no-available': pinkRowsWithFace.length === 0 && grayCouponsWithFace.length > 0 && couponMainExpanded }]"
      >
        <div
          class="goods-item coupon-goods-item"
          role="button"
          tabindex="0"
          :aria-expanded="couponMainExpanded ? 'true' : 'false'"
          aria-label="展开或收起优惠券列表"
          @click="toggleCouponMain"
          @keydown.enter.prevent="toggleCouponMain"
          @keydown.space.prevent="toggleCouponMain"
        >
          <div class="name">优惠券</div>
          <div
            class="coupon-goods-item__body"
            :class="{ 'coupon-goods-item__body--tail-only': couponMainExpanded }"
          >
            <span
              v-if="collapsedShowTag"
              class="coupon-goods-item__tag"
              >{{ collapsedCouponTagText }}</span
            >
            <div class="coupon-goods-item__tail">
              <span
                v-if="headerRightDiscountText"
                class="coupon-goods-item__amount"
                >{{ headerRightDiscountText }}</span
              >
              <span
                v-else-if="offerCount > 0 && !orderCouponLoading"
                class="coupon-goods-item__status"
                >{{ offerCount }}张优惠券可用</span
              >
              <span
                v-else-if="offerCount === 0 && !orderCouponLoading"
                :class="
                  couponMainExpanded
                    ? 'coupon-goods-item__status coupon-goods-item__status--muted'
                    : 'coupon-goods-item__empty'
                "
                >无可用券</span
              >
              <div
                class="coupon-goods-item__arrow"
                :class="{
                  'coupon-goods-item__arrow--expanded': couponMainExpanded
                }"
                :style="couponHeaderArrowBgStyle"
                aria-hidden="true"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 优惠券列表 -->
      <div
        v-if="
          showCouponBlock &&
          couponMainExpanded &&
          (pinkRowsWithFace.length > 0 || grayCouponsWithFace.length > 0)
        "
        class="coupon-cards-stack"
      >
        <div
          v-for="row in pinkRowsWithFace"
          :key="'offer-' + row.offer.couponNo"
          class="coupon-card-align-row"
        >
          <div
            class="cashier-coupon-card coupon-card-align-row__body"
            @click="selectOffer(row.offer.couponNo)"
          >
            <div class="cashier-coupon-card__left">
              <div class="cashier-coupon-card__amount">
                <template v-if="row.face.amountIsCash">
                  <span class="cashier-coupon-card__currency">¥</span>
                  <span class="cashier-coupon-card__num">{{
                    row.face.amountNumText
                  }}</span>
                </template>
                <span
                  v-else
                  class="cashier-coupon-card__num cashier-coupon-card__num--discount"
                  >{{ row.face.amountDiscountText }}</span
                >
              </div>
              <div class="cashier-coupon-card__rule">
                {{ row.face.threshold }}
              </div>
            </div>
            <div class="cashier-coupon-card__gap" aria-hidden="true"></div>
            <div class="cashier-coupon-card__mid">
              <span class="cashier-coupon-card__name">{{
                row.face.title
              }}</span>
            </div>
            <div class="cashier-coupon-card__period">
              {{ row.face.period }}
            </div>
            <div class="cashier-coupon-card__right">
              <img
                class="cashier-coupon-card__check"
                :src="
                  selectedOfferCouponNo === row.offer.couponNo
                    ? couponCheckImages.selected
                    : couponCheckImages.available
                "
                alt=""
                draggable="false"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>

        <div
          v-if="grayCouponsWithFace.length > 0"
          class="coupon-card-align-row coupon-divider-row"
        >
          <div
            class="coupon-divider-with-text coupon-divider-row__inner coupon-card-align-row__body"
          >
            <span class="coupon-divider-with-text__line"></span>
            <span class="coupon-divider-with-text__label"
              >本单不可使用的优惠券</span
            >
            <span class="coupon-divider-with-text__line"></span>
          </div>
        </div>

        <div
          v-for="item in grayCouponsWithFace"
          :key="'gray-' + item.coupon.couponNo"
          class="coupon-card-align-row"
        >
          <div
            class="cashier-coupon-card cashier-coupon-card--disabled coupon-card-align-row__body"
          >
            <div class="cashier-coupon-card__left">
              <div class="cashier-coupon-card__amount">
                <template v-if="item.face.amountIsCash">
                  <span class="cashier-coupon-card__currency">¥</span>
                  <span class="cashier-coupon-card__num">{{
                    item.face.amountNumText
                  }}</span>
                </template>
                <span
                  v-else
                  class="cashier-coupon-card__num cashier-coupon-card__num--discount"
                  >{{ item.face.amountDiscountText }}</span
                >
              </div>
              <div class="cashier-coupon-card__rule">
                {{ item.face.threshold }}
              </div>
            </div>
            <div class="cashier-coupon-card__gap" aria-hidden="true"></div>
            <div class="cashier-coupon-card__mid">
              <span class="cashier-coupon-card__name">{{
                item.face.title
              }}</span>
            </div>
            <div class="cashier-coupon-card__period">
              {{ item.face.period }}
            </div>
            <div class="cashier-coupon-card__right">
              <img
                class="cashier-coupon-card__check"
                :src="couponCheckImages.unavailable"
                alt=""
                draggable="false"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 商品说明 -->
      <div v-if="saleRemark || saleRemarkAppend" class="wrapper">
        <!-- 说明 -->
        <ul v-if="saleRemark" class="service-list">
          <li
            v-for="(item, index) in saleRemark"
            :key="index"
            class="service-item"
            :class="index === 0 ? 'service-title' : ''"
          >
            {{ item }}
          </li>
        </ul>

        <!-- 附加说明 -->
        <ul v-if="saleRemarkAppend" class="note-list">
          <li
            v-for="(item, index) in saleRemarkAppend"
            :key="index"
            class="note-item"
          >
            {{ item }}
          </li>
        </ul>
      </div>

      <!-- 底部 -->
      <footer class="footer cashier-footer-module">
        实付：
        <div class="price">
          <span class="symbol">￥</span>
          {{ displayPayAmountText }}
        </div>
        <el-button
          type="danger"
          class="button-pay"
          @click="createOrder"
          :disabled="payButtonDisabled"
          :loading="loading"
          >立即支付</el-button
        >
      </footer>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
import { PaymentMethods } from '@/constant/PaymentMethods'
import { getOrderCoupon } from '@/api/coupon'

function pick(row, camel, pascal) {
  if (!row) return undefined
  const a = row[camel]
  return a !== undefined && a !== null ? a : row[pascal]
}

function toMs(v) {
  if (v == null) return null
  if (typeof v === 'number') return v
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}

function stripTrailingZeros(num) {
  const s = String(num)
  if (!s.includes('.')) return s
  return s.replace(/\.?0+$/, '')
}

function formatValidity(validFrom, validEnd) {
  const a = toMs(validFrom)
  const b = toMs(validEnd)
  if (!a || !b) return ''
  return `${dayjs(a).format('YYYY.MM.DD')}~${dayjs(b).format('YYYY.MM.DD')}`
}

function formatThreshold(minLimitAmount) {
  const n = Number(minLimitAmount)
  if (!Number.isFinite(n) || n <= 0) return '无门槛'
  return `满${stripTrailingZeros(n)}元可用`
}

function formatDiscountMain(discount) {
  const d = Number(discount)
  if (!Number.isFinite(d) || d <= 0) return '--'
  if (d > 0 && d <= 1) {
    const zhe = d * 10
    return `${stripTrailingZeros(zhe)}折`
  }
  return `${stripTrailingZeros(d)}折`
}

/**
 * 收银台券卡展示（与 MyCoupon 金额/门槛/有效期及 DOM 语义对齐）
 * @param {*} coupon UserCouponApiModel
 * @param {*} [offer] CouponOfferApiModel
 * @returns {{ title, threshold, period, amountLarge, amountIsCash, amountNumText, amountDiscountText }}
 */
function cashierCouponFace(coupon, offer) {
  const c = coupon || {}
  const name = (offer && offer.name) || pick(c, 'name', 'Name') || ''
  const valueAmount = pick(c, 'valueAmount', 'ValueAmount')
  const discount = pick(c, 'discount', 'Discount')
  const minLimitAmount = pick(c, 'minLimitAmount', 'MinLimitAmount')
  const validFrom = pick(c, 'validFrom', 'ValidFrom')
  const validEnd = pick(c, 'validEnd', 'ValidEnd')

  const hasCash =
    valueAmount != null &&
    valueAmount !== '' &&
    Number.isFinite(Number(valueAmount))

  let amountLarge = ''
  let amountIsCash = false
  let amountNumText = ''
  let amountDiscountText = ''

  if (hasCash) {
    amountIsCash = true
    amountNumText = stripTrailingZeros(Number(valueAmount))
    amountLarge = `¥ ${amountNumText}`
  } else {
    const disc = Number(discount)
    if (Number.isFinite(disc) && disc > 0) {
      amountDiscountText = formatDiscountMain(discount)
      amountLarge = amountDiscountText
    } else if (
      offer &&
      Number.isFinite(Number(offer.discountAmount)) &&
      Number(offer.discountAmount) > 0
    ) {
      amountIsCash = true
      amountNumText = stripTrailingZeros(Number(offer.discountAmount))
      amountLarge = `¥ ${amountNumText}`
    } else {
      amountDiscountText = '--'
      amountLarge = '--'
    }
  }

  return {
    title: name,
    threshold: formatThreshold(minLimitAmount),
    period: formatValidity(validFrom, validEnd),
    amountLarge,
    amountIsCash,
    amountNumText,
    amountDiscountText
  }
}

const PaymentMethodsList = new Map([
  [
    PaymentMethods.weXin,
    {
      method: PaymentMethods.weXin,
      name: '微信支付',
      tradeType: 3, // 扫码支付
      icon: require('@/assets/images/cashier-desk/wechat.png')
    }
  ],
  [
    PaymentMethods.aliPay,
    {
      method: PaymentMethods.aliPay,
      name: '支付宝',
      tradeType: 6, // PC支付
      icon: require('@/assets/images/cashier-desk/alipay.png')
    }
  ],
  [
    PaymentMethods.basepayWei,
    {
      method: PaymentMethods.basepayWei,
      name: '微信',
      tradeType: 11, // 扫码支付
      icon: require('@/assets/images/cashier-desk/wechat.png')
    }
  ],
  [
    PaymentMethods.BasepayAli,
    {
      method: PaymentMethods.BasepayAli,
      name: '支付宝',
      tradeType: 8, // PC支付
      icon: require('@/assets/images/cashier-desk/alipay.png')
    }
  ],
  [
    PaymentMethods.Douyinpay,
    {
      method: PaymentMethods.Douyinpay,
      name: '抖音',
      tradeType: 3, // NATIVE 抖音扫码支付
      icon: require('@/assets/images/cashier-desk/douyin2.svg')
    }
  ],
  [
    PaymentMethods.caiBi,
    {
      method: PaymentMethods.caiBi,
      name: '财币',
      icon: require('@/assets/images/cashier-desk/caibi.png')
    }
  ]
])

/** 收银台优惠券勾选图：不可用 / 可用未选 / 可用已选 */
const CouponCheckImages = {
  unavailable: require('@/assets/images/coupon/check_0.png'),
  available: require('@/assets/images/coupon/check_1.png'),
  selected: require('@/assets/images/coupon/check_2.png')
}

const CouponHeaderArrowImg = require('@/assets/images/coupon/icon-down3.png')

export default {
  name: 'BaseGoodsAction',
  props: {
    value: {},
    goodsInfo: {},
    goodsTitle: {},
    goodsNameTitle: {},
    goodsName: {},
    goodsListTitle: {},
    goodsList: {},
    saleRemark: {},
    saleRemarkAppend: {},
    payments: {},
    price: {},
    balance: {},
    loading: {},
    enableCoupon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      PaymentMethods,
      goods: {
        goodsId: '',
        setId: '',
        orderId: ''
      },
      /**
       * 当前选择的商品索引
       */
      activeIndex: 0,
      activePayMethodIndex: 0,
      /**
       * 是否已选择购买协议
       */
      hasAgreementSelected: true,
      /**
       * 是否显示支付动作面板弹框
       */
      hasPayActionSheet: false,
      /**
       * 订单信息
       * @type {OrderInfo}
       */
      orderInfo: null,
      /**
       * 正在创建订单
       */
      createOrderLoading: false,
      PaymentMethodsList,
      orderCouponLoading: false,
      orderOffersList: [],
      orderCouponsList: [],
      /** 主优惠券区展开（默认收起，仅点右侧箭头展开） */
      couponMainExpanded: false,
      /** 空字符串表示不使用券；否则为所选 offer 的 couponNo */
      selectedOfferCouponNo: '',
      couponCheckImages: CouponCheckImages,
      couponHeaderArrowImg: CouponHeaderArrowImg
    }
  },
  computed: {
    hasShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    activeProduct() {
      return this.goodsList && this.goodsList[this.activeIndex]
    },
    orderBaseAmount() {
      const p = this.activeProduct
      if (!p) return 0
      const v = p.price !== undefined && p.price !== null ? p.price : p.value
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    selectedOffer() {
      if (!this.selectedOfferCouponNo) return null
      return (
        this.orderOffersList.find(
          o => o.couponNo === this.selectedOfferCouponNo
        ) || null
      )
    },
    displayPayAmount() {
      const base = this.orderBaseAmount
      const off = this.selectedOffer
      if (!off) return base
      const d = Number(off.discountAmount)
      if (!Number.isFinite(d)) return base
      const cents = Math.round(base * 100 - d * 100)
      return Math.max(0, cents / 100)
    },
    displayPayAmountText() {
      return this.formatMoney(this.displayPayAmount)
    },
    showCouponBlock() {
      return this.enableCoupon !== false && !!this.goodsList
    },
    offerCount() {
      return (this.orderOffersList || []).length
    },
    offerCouponNoSet() {
      const s = new Set()
      ;(this.orderOffersList || []).forEach(o => {
        if (o && o.couponNo) s.add(o.couponNo)
      })
      return s
    },
    pinkRows() {
      return (this.orderOffersList || []).map(offer => {
        const coupon =
          (this.orderCouponsList || []).find(
            c => c && c.couponNo === offer.couponNo
          ) || {}
        return { offer, coupon }
      })
    },
    grayCoupons() {
      const offers = this.offerCouponNoSet
      return (this.orderCouponsList || []).filter(
        c => c && c.couponNo && !offers.has(c.couponNo)
      )
    },
    pinkRowsWithFace() {
      return this.pinkRows.map(row => ({
        ...row,
        face: cashierCouponFace(row.coupon, row.offer)
      }))
    },
    grayCouponsWithFace() {
      return this.grayCoupons.map(c => ({
        coupon: c,
        face: cashierCouponFace(c, null)
      }))
    },
    /**
     * 头部右侧：有选中且可计算优惠时显示 -￥金额（收起/展开一致）
     */
    headerRightDiscountText() {
      if (!this.selectedOfferCouponNo || this.offerCount === 0) return ''
      const off = this.selectedOffer
      if (!off) return ''
      const d = Number(off.discountAmount)
      if (!Number.isFinite(d) || d < 0) return ''
      return `-￥${this.formatMoney(d)}`
    },
    /** 收起条右侧：-￥优惠额（与 headerRightDiscountText 一致，保留供其它处复用） */
    selectedDiscountDisplay() {
      return this.headerRightDiscountText
    },
    /** 收起条左侧红色标签：仅默认首张选中时显示「已选推荐优惠」；用户改选后不再显示标签 */
    collapsedCouponTagText() {
      if (!this.selectedOfferCouponNo || !this.orderOffersList.length) return ''
      const first = this.orderOffersList[0]
      if (first && first.couponNo === this.selectedOfferCouponNo) {
        return '已选推荐优惠'
      } else {
        return '已选1张'
      }
    },
    collapsedShowTag() {
      return !!this.collapsedCouponTagText
    },
    couponHeaderArrowBgStyle() {
      const u = this.couponHeaderArrowImg
      return u ? { backgroundImage: `url("${u}")` } : {}
    },
    payMethod() {
      return this.paymentMethodList[this.activePayMethodIndex].method
    },
    tradeType() {
      return this.paymentMethodList[this.activePayMethodIndex].tradeType
    },
    paymentMethodList() {
      const methodList = []

      this.payments &&
        this.payments.forEach(payMethod => {
          const src = PaymentMethodsList.get(payMethod)
          if (!src) return
          const methodItem = { ...src }
          if (
            methodItem.method === PaymentMethods.caiBi &&
            Number(this.balance) < this.displayPayAmount
          ) {
            methodItem.class = 'payment-mode--disable'
          }

          methodList.push(methodItem)
        })

      return methodList
    },
    /**
     * 是否禁用支付按钮
     * 1. 选择财币支付
     * 2. 财币余额不足
     */
    payButtonDisabled() {
      return (
        this.payMethod === PaymentMethods.caiBi &&
        this.activeProduct &&
        Number(this.balance) < this.displayPayAmount
      )
    }
  },
  watch: {
    activeProduct: {
      immediate: true,
      handler(val, oldVal) {
        if (!this.showCouponBlock) return
        const id = val && val.id
        const oldId = oldVal && oldVal.id
        if (id === oldId && oldVal !== undefined) return
        this.selectedOfferCouponNo = ''
        this.couponMainExpanded = false
        if (id != null) {
          this.orderOffersList = []
          this.orderCouponsList = []
          this.fetchOrderCouponForActive()
        } else {
          this.orderOffersList = []
          this.orderCouponsList = []
        }
      }
    }
  },
  methods: {
    hide() {
      this.hasShow = false
    },
    /**
     * 切换商品
     */
    changeGoods(index) {
      this.activeIndex = index
    },
    changePayMethod(index) {
      const m = this.paymentMethodList[index]
      if (m && m.class === 'payment-mode--disable') return
      this.activePayMethodIndex = index
    },
    selectOffer(couponNo) {
      if (this.selectedOfferCouponNo === couponNo) {
        this.selectedOfferCouponNo = ''
      } else {
        this.selectedOfferCouponNo = couponNo
      }
    },
    toggleCouponMain() {
      this.couponMainExpanded = !this.couponMainExpanded
    },
    setActiveIndex(index) {
      if (!this.goodsList || index < 0 || index >= this.goodsList.length) {
        return
      }
      this.activeIndex = index
    },
    formatMoney(n) {
      const x = Number(n)
      if (!Number.isFinite(x)) return '0.00'
      return x.toFixed(2)
    },
    async fetchOrderCouponForActive() {
      if (!this.showCouponBlock) return
      const id = this.activeProduct && this.activeProduct.id
      if (id == null) {
        this.orderOffersList = []
        this.orderCouponsList = []
        this.selectedOfferCouponNo = ''
        this.couponMainExpanded = false
        return
      }
      this.orderCouponLoading = true
      const res = await getOrderCoupon(id)
      this.orderCouponLoading = false
      if (!res || res.result.code !== 0) {
        this.orderOffersList = []
        this.orderCouponsList = []
        this.selectedOfferCouponNo = ''
        this.couponMainExpanded = false
        return
      }
      const d = res.detail || {}
      this.orderOffersList = Array.isArray(d.offers) ? d.offers : []
      this.orderCouponsList = Array.isArray(d.coupons) ? d.coupons : []
      if (this.orderOffersList.length > 0) {
        const first = this.orderOffersList[0]
        this.selectedOfferCouponNo =
          first && first.couponNo ? first.couponNo : ''
      } else {
        this.selectedOfferCouponNo = ''
      }
      this.couponMainExpanded = false
    },
    createOrder() {
      let couponNos = null
      if (this.enableCoupon !== false) {
        couponNos = this.selectedOfferCouponNo
          ? [this.selectedOfferCouponNo]
          : null
      }
      this.$emit('pay', {
        ...this.activeProduct,
        payMethod: this.payMethod,
        tradeType: this.tradeType,
        couponNos
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* class 作用在 el-dialog 的根节点 .el-dialog__wrapper 上；avoid align-items:center，
   否则会垂直居中整块 .el-dialog，内容高于视口时无法通过滚动看到弹窗顶端 */
.cashier-desk {
  display: flex;
  align-items: flex-start;
  justify-content: center;

  ::v-deep {
    .el-dialog {
      border-radius: 8px;
      overflow: hidden;
    }

    .el-dialog__header {
      padding-bottom: 0;
    }
  }
}

.header {
  margin: 10px 0 0;
  padding-top: 64px;
  font-size: 16px;
  color: #858585;
  text-align: center;
  background: url('~@/assets/images/common/logo.png') no-repeat top;
  background-size: 52px auto;
}

.cashier-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

$wrapper-width: 792px;

/* 优惠券列表卡片：与 MyCoupon.vue `.coupon-card` 视觉对齐 */
$coupon-orange: #e64c2e;
$coupon-bg-active: #fff5f2;
$coupon-bg-disabled: #f5f5f5;
$coupon-card-height: 80px;

.wrapper {
  width: $wrapper-width;
  max-width: 100%;
  margin: 0 auto 20px;
  background-color: #fafbfc;
  border: solid 1px #ebebeb;
  border-radius: 8px;
  overflow: hidden;
  padding: 30px 20px 30px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.payment-methods-wrapper {
  > .goods-item {
    align-items: center;
  }
}

.goods-wrapper {
  border-top: 6px solid #046bcc;
}

.title {
  padding-top: 6px;
  padding-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
  color: #262626;
}

.goods-item {
  display: flex;

  .name {
    flex: 0 0 100px;
    font-size: 16px;
    color: #858585;
  }

  .goods-name {
    font-size: 16px;
    font-weight: bold;
    color: #262626;
  }
}

/* 仅商品两行布局：第二行与第一行留白；勿作用于仅含一行内容的 wrapper（如支付方式）*/
.goods-wrapper .goods-item:last-child {
  padding-top: 20px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: auto;

  .col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 0 0 194px;
    height: 90px;
    background-color: #ffffff;
    border-radius: 8px;
    border: solid 1px #ebebeb;
    padding: 0 10px;
    margin-right: 30px;
    cursor: pointer;

    &.active {
      position: relative;
      border-color: #046bcc;
      background-image: linear-gradient(
        -45deg,
        #046bcc 0,
        #046bcc 15px,
        #ffffff 17px,
        #ffffff 100%
      );

      &::after {
        content: '';
        position: absolute;
        right: 2px;
        bottom: 5px;
        width: 10px;
        height: 6px;
        border-left: 2px solid #ffffff;
        border-bottom: 2px solid #ffffff;
        box-sizing: border-box;
        transform: rotate(-45deg);
      }
    }

    .set-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 16px;
      color: #262626;
      line-height: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        color: #046bcc;
      }
    }

    .payment-mode-icon {
      border-radius: 9px;
    }

    .price {
      padding-top: 12px;
      font-size: 20px;
      color: #e64c2e;
      line-height: 1;

      .symbol {
        font-size: 16px;
      }
    }
  }
}

.payment-mode-list {
  flex: 1;
  min-width: 0;
  flex-wrap: nowrap;

  .col {
    flex-direction: row;
    flex: 1 1 0;
    min-width: 0;
    max-width: none;
    margin-bottom: 0;
    margin-right: 12px;

    &:last-child {
      margin-right: 0;
    }
  }

  img {
    width: 38px;
    margin-right: 16px;
  }

  .col.payment-mode--disable {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

.balance-num {
  color: #046bcc;
  font-size: 13px;
  margin-top: 4px;
}

.coupon-header-wrapper {
  height: 80px;

  &--no-available {
    margin-bottom: 8px;
  }

  > .goods-item.coupon-goods-item {
    padding-top: 0;
    align-items: center;
    cursor: pointer;
    height: 26px;

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid #046bcc;
      outline-offset: 2px;
      border-radius: 4px;
    }
  }
}

.coupon-cards-stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: $wrapper-width;
  max-width: 100%;
  margin: 0 auto 20px;
  box-sizing: border-box;
  flex-shrink: 0;
  background: transparent;
}

.coupon-card-align-row {
  display: flex;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;

  &__gutter {
    flex: 0 0 100px;
    width: 100px;
    min-width: 100px;
  }

  &__body {
    flex: 1;
    min-width: 0;
  }
}

.coupon-divider-row__inner.coupon-divider-with-text {
  margin-top: 0;
  margin-bottom: 0;
  width: 100%;
  max-width: 100%;
}

.coupon-goods-item {
  &__body {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  &__body--tail-only {
    justify-content: flex-end;
  }

  &__tag {
    display: inline-block;
    padding: 2px 8px;
    font-size: 13px;
    font-weight: normal;
    color: #e64c2e;
    border: 1px solid #e64c2e;
    border-radius: 4px;
    background: #ffffff;
    line-height: 1.4;
    flex-shrink: 0;
  }

  &__tail {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 8px;
    margin-left: auto;
  }

  &__amount {
    font-size: 16px;
    font-weight: bold;
    color: #e64c2e;
    white-space: nowrap;
  }

  &__empty {
    font-size: 16px;
    font-weight: normal;
    color: #858585;
    white-space: nowrap;
  }

  &__status {
    font-size: 16px;
    font-weight: normal;
    color: #e64c2e;
    white-space: nowrap;

    &--muted {
      color: #858585;
    }
  }

  &__arrow {
    display: inline-block;
    width: 16px;
    height: 14px;
    flex-shrink: 0;
    pointer-events: none;
    user-select: none;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    transition: transform 0.2s ease;

    &--expanded {
      transform: rotate(180deg);
    }
  }
}

.coupon-divider-with-text {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
  margin: 8px 0 4px;
  gap: 12px;
  box-sizing: border-box;

  &__line {
    flex: 1 1 0;
    min-width: 0;
    height: 1px;
    align-self: center;
    background: #e8e8e8;
  }

  &__label {
    flex-shrink: 0;
    font-size: 14px;
    color: #8c8c8c;
    white-space: nowrap;
  }
}

.cashier-coupon-card {
  position: relative;
  display: flex;
  align-items: stretch;
  height: $coupon-card-height;
  box-sizing: border-box;
  background: $coupon-bg-active;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  &--disabled {
    cursor: default;
    pointer-events: none;
    background: $coupon-bg-disabled;

    .cashier-coupon-card__currency,
    .cashier-coupon-card__num,
    .cashier-coupon-card__rule,
    .cashier-coupon-card__name,
    .cashier-coupon-card__period {
      color: #8c8c8c;
    }

    .cashier-coupon-card__amount {
      opacity: 0.85;
      font-family: PingFang SC, PingFang SC-Regular, sans-serif;
    }
  }

  &__left {
    flex: 0 0 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-width: 0;
  }

  &__amount {
    display: flex;
    align-items: baseline;
    justify-content: center;
    flex-wrap: nowrap;
    height: 30px;
    line-height: 30px;
    color: $coupon-orange;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__currency {
    font-size: 18px;
    font-weight: 600;
    margin-right: 2px;
  }

  &__num {
    font-size: 32px;
    font-weight: 700;
    letter-spacing: -1px;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;

    &--discount {
      font-size: 28px;
    }
  }

  &__rule {
    margin-top: 11px;
    height: 15px;
    line-height: 15px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular, sans-serif;
    color: #858585;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  &__gap {
    flex: 0 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: $coupon-card-height;
    background-image: url('~@/assets/images/coupon/devider.png');
    background-repeat: no-repeat;
    background-position: center;
    flex-shrink: 0;
    box-sizing: border-box;
  }

  &__mid {
    flex: 1 1 0;
    display: flex;
    align-items: center;
    min-width: 0;
    padding-left: 40px;
  }

  &__name {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    max-width: 100%;
  }

  &__period {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 35px;
    color: #858585;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular, sans-serif;
    font-weight: 400;
  }

  &__right {
    flex: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 30px;
    min-width: 0;
  }

  &__check {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    object-fit: contain;
    display: block;
    user-select: none;
    pointer-events: none;
  }
}

.service-list {
  font-size: 16px;
  color: #262626;
  line-height: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.note-list {
  font-size: 16px;
  color: #858585;
  line-height: 24px;
  padding-bottom: 10px;
}

.footer.cashier-footer-module {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 auto 20px;
  width: $wrapper-width;
  max-width: 100%;
  height: 80px;
  padding: 0 20px;
  background-color: #fafbfc;
  border: solid 1px #ebebeb;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
  flex-shrink: 0;
  box-shadow: none;

  .price {
    font-size: 20px;
    color: #e64c2e;
    line-height: 1;

    .symbol {
      font-size: 16px;
    }
  }

  .button-pay {
    width: 160px;
    height: 48px;
    margin: 0 30px;
    background-color: #e64c2e;
    border-radius: 24px;
    font-size: 16px;
  }
}
</style>
